import api from '../../../../api';
import PageHeader from '../../../components/PageHeader';
import PageStatic from '../../../components/PageStatic';
import PageTitle from '../../../components/PageTitle';
import { withPageData } from '../../../hoc/withPageData';
import AdminBreadcrumbs from '../components/AdminBreadcrumbs';
import styles from './style.m.less';
import { CompanySettingsAdvancedDto, DateTimeSettingsDto } from './types';

import AdminCompanySettings from './presenter';

export type AdminCompanySettingsPageProps = {
    companySettingsAdvanced: CompanySettingsAdvancedDto;
    dateTimeSettings: DateTimeSettingsDto;
};

function AdminCompanySettingsPage({ companySettingsAdvanced, dateTimeSettings }: AdminCompanySettingsPageProps) {
    const title = 'Company Settings';
    return (
        <PageStatic className={styles.companySettingsPageWrapper}>
            <AdminBreadcrumbs page={title} />
            <PageTitle title={title} />
            <PageHeader title={title} />
            <AdminCompanySettings
                companySettingsAdvanced={companySettingsAdvanced}
                dateTimeSettings={dateTimeSettings}
            />
        </PageStatic>
    );
}

export default withPageData<
    { companySettingsAdvanced: CompanySettingsAdvancedDto; dateTimeSettings: DateTimeSettingsDto },
    void
>({
    resolve: {
        companySettingsAdvanced: () => api.companySettingsAdvanced.getCompanySettingsAdvanced(),
    },
    observe: {
        dateTimeSettings: () => api.companyDateTimeSettings.getDateTimeSettings.createObservable(),
    },
})(AdminCompanySettingsPage);
